import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Navbar, Nav, Form } from 'react-bootstrap';
import logo from '../../../assets/Icono_SinFondo.png';
import './Header.css';

function Header() {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <Navbar 
      fixed="top" 
      expand="md" 
      className="header-navbar"
      bg="dark"
      variant="dark"
    >
      <Container>
        <Navbar.Brand href="#" className="header-brand">
          <img
            src={logo}
            alt={t('header.logoAlt')}
            className="header-logo-img d-inline-block align-top"
          />
        </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
        
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="header-nav">
            <Nav.Link href="#about" className="header-nav-link">
              {t('header.about')}
            </Nav.Link>
            <Nav.Link href="#contact" className="header-nav-link">
              {t('header.contact')}
            </Nav.Link>
            <Form.Select 
              name="languaje" 
              className="header-select"
              size="sm"
              value={i18n.language}
              onChange={(e) => changeLanguage(e.target.value)}
            >
              <option value="es">ES</option>
              <option value="en">EN</option>
            </Form.Select>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;
